function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// DO NOT EDIT THIS FILE BECAUSE IT IS GENERATED AUTOMATICALLY
import React from "react";
import PropTypes from "prop-types";

const Bold = _ref => {
  let {
    size = "1em",
    color = "currentColor",
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    style: {
      width: size,
      height: size
    },
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: title ? 'img' : 'presentation'
  }), title ? /*#__PURE__*/React.createElement("title", null, title) : null, " ", /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M5.5 3.5h5.888c2.294 0 3.997.343 5.109 1.03 1.112.685 1.668 1.753 1.668 3.203 0 .953-.242 1.767-.727 2.441a3.244 3.244 0 0 1-1.917 1.303v.116c1.047.28 1.805.744 2.275 1.395.47.652.704 1.496.704 2.535 0 1.543-.575 2.758-1.726 3.646-1.15.887-2.719 1.331-4.705 1.331H5.5v-17zm4.56 6.523h1.374c.655 0 1.16-.135 1.518-.407.358-.271.537-.674.537-1.209 0-.954-.715-1.43-2.147-1.43H10.06v3.046zm0 3.36v3.57h1.605c1.424 0 2.136-.604 2.136-1.813 0-.566-.19-1-.571-1.303-.381-.302-.934-.453-1.657-.453H10.06z"
  }, " "));
};

Bold.propTypes = {
  /** The width/height of the icon as any CSS size unit */
  size: PropTypes.string,

  /** The fill color of the icon as any CSS color value */
  color: PropTypes.string,

  /** The title to add as a child of the root svg element */
  title: PropTypes.string
};
export default Bold;